import { Nullable } from '@internal-libraries/kheops-ui-lib'
import Service from './ClvrService'
import Bed from './ClvrBed'
import { AffectationType } from '../Types/AffectationType'
import { AffectationDto } from '../Types/AffectationDto'

export default class Affectation {
    public id: Nullable<number> = null
    public serviceId: Nullable<number> = null
    public bedId: Nullable<number> = null

    public service?: Service
    public bed?: Bed

    public constructor(data?: AffectationType) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): AffectationDto {
        return {
            affectation_id: this.id,
            service_id: this.serviceId,
            lit_id: this.bedId,
            _ref_service: this.service?.toDto(),
            _ref_lit: this.bed?.toDto(),
        }
    }
}
